import { Field, InputType } from 'type-graphql'

/**
 * Shape hint for the `/change-password` REST route's JSON body (`BasicAuthRouter.resetPasswordMiddleware`)
 * — not a resolver arg (the route reads `req.body` directly, unvalidated by this class). Used only
 * by `UserTestHelper.changePassword()` for typed test payloads. `{username, code}` replaced `token`:
 * the route now redeems a single-use, server-minted 6-digit code by a COMPOUND match against the
 * named account (`UserService.createPasswordResetCode` / `redeemPasswordResetCode`) instead of a
 * global lookup by an opaque token.
 */
@InputType()
export class BasicAuthChangePasswordArgs {
  @Field(() => String)
  recaptchaToken: string

  @Field(() => String)
  newPassword: string

  @Field(() => String)
  confirmPassword: string

  @Field(() => String)
  username: string

  @Field(() => String)
  code: string
}
